// Definitions needed to communicate between the Dipai portal administration page (client), and the edge device manager (server)
import { z } from "zod";
import { Logger } from "./Logger.js";
import { MessageDefinition } from "./MessageDefinition.js";
import { initMessageDefinitions } from "./initMessageDefinitions.js";
export const LoginArgs = z.object({
    userId: z.number(),
    token: z.string(),
});
export const PermitDeviceArgs = z.object({
    entryId: z.number(),
    plantId: z.number(),
});
export const EmptyMessage = z.object({});
export const entryIdObject = z.object({ entryId: z.number() });
export const deviceIdObject = z.object({ deviceId: z.number() });
export const CreateDevicePlantArgs = z.object({
    entryId: z.number(),
    companyId: z.number(),
    plantName: z.string(),
    plantMmsi: z.nullable(z.number()),
    plantImo: z.nullable(z.number()),
});
export const DeviceSshInfo = z.object({
    userName: z.string(),
    port: z.number(),
});
export const AddDeviceEntry = z.object({
    entryId: z.number(),
    ip: z.string(),
    credentials: z.nullable(z.object({
        dbId: z.number(),
        name: z.string(),
        sshInfo: z.nullable(DeviceSshInfo),
    })),
    createdAt: z.string(),
    generatedTimestamp: z.nullable(z.string()),
});
export const RemoveDeviceEntry = z.object({
    entryId: z.number(),
});
export const Plant = z.object({ id: z.number(), name: z.string() });
export const Company = z.object({
    id: z.number(),
    name: z.string(),
});
export const Device = z.object({ id: z.number(), name: z.string() });
export const PageInfo = z.object({
    plants: z.array(Plant),
    companies: z.array(Company),
    loggerKeys: z.array(z.string()),
    logEntrySeverities: z.array(z.string()),
    devices: z.array(Device),
});
export const InfoMessage = z.object({ text: z.string() });
export const AddDeviceAppEntry = z.object({
    entryId: z.number(),
    name: z.string(),
    onlineSince: z.string(),
});
export const RemoveDeviceAppEntry = z.object({ entryId: z.number() });
export const OpenLoggerStreamArgs = z.object({
    entryId: z.number(),
    key: z.string(),
    severity: z.array(z.string()),
});
export const LoggerStreamItem = z.object({
    key: z.string(),
    severity: z.string(),
    timestamp: z.string(),
    lines: z.array(z.string()),
});
export const FetchLogEntriesArgs = z.object({
    entryId: z.number(),
    key: z.string(),
    severity: z.array(z.string()),
});
export const ConfigJsonFetchArgs = z.object({
    entryId: z.number(),
    requestId: z.number(),
});
export const ConfigJsonFetchResult = z.object({
    requestId: z.number(),
    data: z.nullable(z.string()),
    message: z.optional(z.nullable(z.string())),
});
export const ConfigJsonPushArgs = z.object({
    requestId: z.number(),
    entryId: z.number(),
    data: z.string(),
});
export const ConfigJsonPushResult = z.object({
    requestId: z.number(),
    message: z.optional(z.string()),
});
export const IssueDeviceSendDataArgs = z.object({
    entryId: z.number(),
    timestampGt: z.string(),
    timestampLt: z.string(),
});
export const edgeAdminApi = {
    fromPortal: initMessageDefinitions({
        login: new MessageDefinition(LoginArgs),
        permitDevice: new MessageDefinition(PermitDeviceArgs),
        refresh: new MessageDefinition(EmptyMessage),
        generateSshInfo: new MessageDefinition(entryIdObject),
        initSshTunnel: new MessageDefinition(entryIdObject),
        stopSshTunnel: new MessageDefinition(entryIdObject),
        revokeDeviceAccess: new MessageDefinition(deviceIdObject),
        doDockerComposePull: new MessageDefinition(entryIdObject),
        doDockerComposeUp: new MessageDefinition(entryIdObject),
        doDockerComposeDown: new MessageDefinition(entryIdObject),
        doEraseCredentials: new MessageDefinition(entryIdObject),
        openDataStream: new MessageDefinition(entryIdObject),
        createDevicePlant: new MessageDefinition(CreateDevicePlantArgs),
        fetchLogEntries: new MessageDefinition(FetchLogEntriesArgs),
        fetchConfigJson: new MessageDefinition(ConfigJsonFetchArgs),
        pushConfigJson: new MessageDefinition(ConfigJsonPushArgs),
        issueDeviceSend: new MessageDefinition(IssueDeviceSendDataArgs),
        updateAllDevices: new MessageDefinition(z.object({})),
    }),
    toPortal: initMessageDefinitions({
        addClient: new MessageDefinition(AddDeviceEntry),
        removeClient: new MessageDefinition(RemoveDeviceEntry),
        infoMessage: new MessageDefinition(InfoMessage),
        addAppClient: new MessageDefinition(z.array(AddDeviceAppEntry)),
        removeAppClient: new MessageDefinition(RemoveDeviceAppEntry),
        dataStreamItem: new MessageDefinition(z.string()),
        pageInfo: new MessageDefinition(PageInfo),
        logger: new MessageDefinition(Logger),
        configJsonFetchResult: new MessageDefinition(ConfigJsonFetchResult),
        configJsonPushResult: new MessageDefinition(ConfigJsonPushResult),
    }),
};
//# sourceMappingURL=edgeAdminApi.js.map